import { render, staticRenderFns } from "./ResIcon.vue?vue&type=template&id=42d4b578&scoped=true&"
import script from "./ResIcon.vue?vue&type=script&lang=js&"
export * from "./ResIcon.vue?vue&type=script&lang=js&"
import style0 from "./ResIcon.vue?vue&type=style&index=0&id=42d4b578&scoped=true&lang=css&"
import style1 from "./ResIcon.vue?vue&type=style&index=1&id=42d4b578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d4b578",
  null
  
)

export default component.exports